
import React from "react";
import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";

interface DefaultHspOptionProps {
  onUseDefaultHSP: () => void;
}

export const DefaultHspOption = ({ onUseDefaultHSP }: DefaultHspOptionProps) => {
  return (
    <div className="mt-2 bg-amber-50 p-4 rounded-lg border border-amber-200">
      <div className="flex items-start gap-2">
        <Info className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="font-medium text-amber-800">Dados não encontrados?</h4>
          <p className="text-sm text-amber-700 mt-1">
            Se não foi possível carregar os dados de irradiação, você pode prosseguir com o valor padrão de 4,80 kWh/m²/dia.
          </p>
          <Button 
            onClick={onUseDefaultHSP} 
            size="sm" 
            variant="outline" 
            className="mt-2 border-amber-300 text-amber-800 hover:bg-amber-100"
          >
            Usar HSP padrão (4,80)
          </Button>
        </div>
      </div>
    </div>
  );
};
